export const REFRESH_DATA = '@manakin/core/dist/REFRESH_DATA';

export function refreshData(name) {
    return {
        type: REFRESH_DATA,
        payload: {
            name,
        },
    };
}
